<template>
  <div class="hero-section mt-24 flex justify-center">
    <div
      class="relative w-full flex flex-col space-y-12 sm:flex-row sm:space-y-0 sm:space-x-8 content-wrapper"
    >
      <div class="w-full">
        <h1 class="mb-4">
          Du suchst den passenden Job?<br />Wir finden ihn für Dich!
        </h1>
        <p class="mb-12 sm:w-1/2">
          Entdecke mit dem XING Job-Agenten Arbeitgeber und Jobs, die das
          passende Setup für Dein Job-Leben bieten.
        </p>
        <CallToActionButton
          bg-color="#00d296"
          text-color="#ffffff"
          :has-border="false"
          @clicked="$emit('launchAgent')"
          >Jetzt starten</CallToActionButton
        >
      </div>
      <img class="xing-shape" src="@/assets/images/xing-shape.png" />
      <img
        class="dashed-line"
        src="@/assets/images/dashed-line.svg"
        alt="Dashed Line"
      />
    </div>
  </div>
</template>

<script>
import CallToActionButton from "../form/CallToActionButton.vue";
export default {
  components: { CallToActionButton },
  name: "HeroSection",
};
</script>

<style lang="postcss" scoped>
p {
  font-size: 25px;
  line-height: 35px;
}

.xing-shape {
  @apply absolute hidden;
}

.dashed-line {
  @apply absolute hidden;
}

@media (min-width: 1024px) {
  .xing-shape {
    @apply block;
    left: -36%;
    bottom: -40%;
    z-index: -1;
  }

  .dashed-line {
    @apply block;
    right: -33.3%;
    bottom: -100%;
    transform: rotate(-45deg);
  }
}
</style>
